export default "__VITE_ASSET__IXG46FI0__"